export default __webpack_public_path__ + "static/media/astrophotography.73c1eab2.png";